import arrayMax from "./max";
import arrayMin from "./min";
export default (function (_a) {
    var data = _a.data, limit = _a.limit, _b = _a.width, width = _b === void 0 ? 1 : _b, _c = _a.height, height = _c === void 0 ? 1 : _c, _d = _a.margin, margin = _d === void 0 ? 0 : _d, _e = _a.max, max = _e === void 0 ? arrayMax(data) : _e, _f = _a.min, min = _f === void 0 ? arrayMin(data) : _f;
    var len = data.length;
    if (limit && limit < len) {
        data = data.slice(len - limit);
    }
    var vFactor = (height - margin * 2) / (max - min || 2);
    var hFactor = (width - margin * 2) / ((limit || len) - (len > 1 ? 1 : 0));
    return data.map(function (d, i) { return ({
        x: i * hFactor + margin,
        y: (max === min ? 1 : max - d) * vFactor + margin,
    }); });
});
